<template>
  <div>
    <div v-bind:style="bgc" class="section" data-cy="testScreen"
         :class="{fullHeight: shouldApplyHeightCalc }">
      <div class="row p-0 m-0" style="height: calc(100vh - 13rem);">
        <div class="col align-self-center">
          <test-pattern-text :selected-test-pattern-id="selectedTestPatternId"></test-pattern-text>
        </div>
      </div>
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-6 col-sm-2 mb-2 mb-sm-0">
            <selection-item v-bind:style="bgc" v-on:selected="selected"
                            :item="{id: -2, label: '-2', icon:'thumbs-down', scale:this.button.iconScale, labelStyle: this.button.labelStyle}"/>
          </div>
          <div class="col-6 col-sm-2 mb-2 mb-sm-0">
            <selection-item v-bind:style="bgc" v-on:selected="selected"
                            :item="{id: -1, label: '-1', icon:'frown', scale:this.button.iconScale, labelStyle: this.button.labelStyle}"/>
          </div>
          <div class="col-12 col-sm-3 mb-2 mb-sm-0">
            <selection-item v-bind:style="bgc" v-on:selected="selected"
                            :item="{id: 0, label: '0', icon:'meh', scale:this.button.iconScale, labelStyle: this.button.labelStyle}"/>
          </div>
          <div class="col-6 col-sm-2 mb-2 mb-sm-0">
            <selection-item v-bind:style="bgc" v-on:selected="selected"
                            :item="{id: 1, label: '+1', icon:'smile', scale:this.button.iconScale, labelStyle: this.button.labelStyle}"/>
          </div>
          <div class="col-6 col-sm-2 mb-2 mb-sm-0">
            <selection-item v-bind:style="bgc" v-on:selected="selected"
                            :item="{id: 2, label: '+2', icon:'thumbs-up', scale:this.button.iconScale, labelStyle: this.button.labelStyle}"/>
          </div>
        </div>
      </div>
      <div v-if="!isFullScreen" class="statsComponent" :class="{'position-absolute' : shouldApplyHeightCalc, 'statsComponentSmallScreen' : !shouldApplyHeightCalc }">
        Filters Left: {{ filters.length }}
      </div>
    </div>

    <modal name="playoff" :click-to-close="false" :adaptive="true" width="320px" height="auto">
      <playoff-modal v-on:go-to-results="navigateToResultScreen" v-on:do-playoff="closeModalAndUseNextFilter"
                     :numPlayoff="playoff.currentNumFiltersInPlayoff"></playoff-modal>
    </modal>

    <v-dialog :click-to-close="false"/>


  </div>
</template>

<script>
  import SelectionItem from './selectionComponent/SelectionItem';
  import PlayoffModal from './PlayoffModal';
  import TestPatternText from './TestPatternText';
  import FilterService from '../services/FiltersService';

  export default {
    name: 'TestScreen',
    components: { TestPatternText, PlayoffModal, SelectionItem },
    props: ['selectedTestPatternId', 'selectedTestTypeId', 'isFullScreen'],
    data() {
      return {
        fullscreenChange: true,
        bgc: {
          backgroundColor: '',
          color: 'dark_gray',
        },
        button: {
          labelStyle: 'font-size:1.2rem; font-weight:bold;',
          iconScale: 1,
        },
        currentFilter: null,
        filters: [],
        baselineFilter: null,
        serverErrors: [],
        results: [],
        testId: '',
        shouldApplyHeightCalc: true,
        playoff: {
          wasChecked: false,
          running: false,
          runs: 0,
          maxRuns: 5,
          currentNumFiltersInPlayoff: 0,
        },
        isPlayoffModalActive: false,
      };
    },
    mounted() {
      const testType = this.selectedTestTypeId ? this.selectedTestTypeId : this.$route.query.selectedTestTypeId;
      const patternId = this.selectedTestPatternId ? this.selectedTestPatternId : this.$route.query.selectedTestPatternId;
      FilterService.init(testType, patternId);
      const testConfig = FilterService.testConfig;
      this.filters = testConfig.filters;
      this.baselineFilter = testConfig.baseline;
      this.testId = testConfig.testId;
      this.useNextFilter();
      this.calculateShouldApplyHeightCalc();
    },
    methods: {
      calculateShouldApplyHeightCalc() {
        const smallWidth = 567;
        this.shouldApplyHeightCalc = window.innerWidth >= smallWidth;
        const self = this;
        window.addEventListener('resize', function () {
          self.shouldApplyHeightCalc = window.innerWidth >= smallWidth;
        });
      },
      selected(selectionId) {
        const resItem = Object.assign(this.currentFilter, {
          rating: selectionId,
          playoff: this.playoff.running,
          payoffRun: this.playoff.runs,
          id: this.testId,
        });
        FilterService.report(resItem);

        this.results.push(resItem);
        if (this.filters.length === 0) {
          this.dealWithZeroFilters();
        } else {
          this.useNextFilter();
        }
      },
      dealWithZeroFilters() {
        if (this.prepPlayoff()) {
          if (!this.playoff.running) {
            this.playoff.running = true;
            this.$modal.show('playoff');
          } else {
            this.useNextFilter();
          }
        } else {
          this.navigateToResultScreen();
        }
      },
      closeModalAndUseNextFilter() {
        this.useNextFilter();
        this.$modal.hide('playoff');
      },
      useNextFilter() {
        this.currentFilter = this.filters.pop();
        this.bgc.backgroundColor = `rgb(${this.currentFilter.red}, ${this.currentFilter.green}, ${this.currentFilter.blue})`;
      },
      navigateToResultScreen() {
        this.$router.push({
          name: 'ResultsScreen',
          params: {
            testId: this.testId,
          },
        });
      },
      prepPlayoff() {
        if (this.playoff.runs >= this.playoff.maxRuns) {
          return false;
        }
        let result = false;
        if (this.results && this.results.length > 0) {
          const ratingsArr = this.results.map(item => item.rating);
          const highestRating = Math.max(...ratingsArr);
          // only playoff if rating goes above 0
          if (highestRating > 0) {
            const highestFilters = this.results.filter(item => item.rating === highestRating && !item.baseline);

            // only playoff if there less than 5 filters to playoff
            if (highestFilters.length > 1 && highestFilters.length < 4) {
              this.playoff.currentNumFiltersInPlayoff = highestFilters.length;
              highestFilters.sort((a, b) => a.sortOrder - b.sortOrder);
              result = true;
              this.playoff.runs += 1;
              this.filters = this.insertBaseline(highestFilters, this.baselineFilter);
              this.results = [];
            }
          }
        }
        return result;
      },
      insertBaseline(highestFilters, baselineFilter) {
        // now we need to insert baseline filter between any 2 non-baseline filters
        const playoffFilters = [];
        // start with false so very first one is the baseline
        // this way when it goes between playoffs there will be a baseline color
        let isLastBaseLine = false;
        highestFilters.forEach((item) => {
          if (!isLastBaseLine && !item.baseline) {
            playoffFilters.push(Object.assign({}, baselineFilter));
          }
          playoffFilters.push(Object.assign({}, item));
          isLastBaseLine = item.baseline;
        });
        let i = 0;
        playoffFilters.map((item) => {
          i += 1;
          return Object.assign(item, { sortOrder: i });
        });
        return playoffFilters;
      },
    },
  };
</script>

<style scoped>
  .statsComponent {
    /*position: absolute;*/
    bottom: 1rem;
    right: 1rem;
  }

  .statsComponentSmallScreen {
    padding: 1rem;
    /*float: right;*/
  }

  .fullHeight {
    height: calc(100vh);
  }
</style>
